import PincodeScreen from './PincodeScreen';

export default PincodeScreen;
